import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=e149f236&scoped=true&lang=pug&"
import script from "./notifications.vue?vue&type=script&lang=coffee&"
export * from "./notifications.vue?vue&type=script&lang=coffee&"
import style0 from "./notifications.vue?vue&type=style&index=0&id=e149f236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e149f236",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/opt/buildhome/repo/components/notifications/notification.vue').default})
